import objFactory from "_src/engine/factories/object";
import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";
import {attachmentId, pixelBufferType, primitiveType} from "_src/engine/constants";
import Camera from "_src/engine/camera";

import Pass from "_src/render_graph/pass";
import resourceManager from "_src/render_graph/resource_manager";
import {screenUtils} from "_src/client/utils";
import CopyShader from "_src/shaders/copy/copy";
import config from "_src/config";

export default class BackgroundPass extends Pass {

  constructor(attachmentsStorage) {

    super(attachmentsStorage);

    this.init();

  }

  init() {
    const camera = new Camera();
    const shader = new CopyShader({transparent : true});

    const backGroundScene = this._addScene(camera);
    this.backgroundObject = objFactory.createDrawable(shader);
    this.backgroundObject.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));
    backGroundScene.add(this.backgroundObject);
    const bc = config.backgroundColor;
    backGroundScene.setClearColor(bc.r, bc.g, bc.b, 0);

    this.backgroundObject.setVisibility(false);
  }

  update() {
    const drawScene = this.getMainScene();

    const width = drawScene.camera.viewport[2];
    const height = drawScene.camera.viewport[3];
    const drawFB = this.initFramebuffer(width, height);
    drawScene.setFramebuffer(drawFB);
    this.setTexture(config.backgroundTexture);
  }

  initFramebuffer(width, height) {
    const usedTexture = this.attachmentsStorage[attachmentId.BASE_COLOR_TEXTURE];
    const texture = usedTexture ? usedTexture : resourceManager.initBuffer(pixelBufferType.T_RGBA,
       {width, height});
    this.attachmentsStorage[attachmentId.BASE_COLOR_TEXTURE] = texture;

    const drawFB = new FrameBuffer([texture], null);
    return drawFB;
  }

  setTexture(texture) {
    if (texture) {
      this.backgroundObject.setTexture(texture, 0);
      this._resize();
    } else {
      this.backgroundObject.cleanupTextures();
    }
    this.backgroundObject.setVisibility(Boolean(texture));
  }

  resize(width, height) {
    super.resize(width, height);
    this._resize();
  }

  _resize() {
    const texture = this.backgroundObject.textures[0];
    if (texture) {
      const scene = this.getMainScene();

      const chunk = this.backgroundObject.chunks[0];
      const geometry = chunk.geometry;
      const positions = geometry.getItemBuffer("a_position");

      const pixelRation = screenUtils.getPixelRatio();

      const width = scene.framebuffer.colorAttachments[0].width / pixelRation;
      const height = scene.framebuffer.colorAttachments[0].height / pixelRation;

      positions[1 * 3] = -1 + 2 * texture.width / width;
      positions[3 * 3] = -1 + 2 * texture.width / width;

      positions[3 * 0 + 1] = 1 - 2.0 * texture.height / height;
      positions[3 * 1 + 1] = 1 - 2.0 * texture.height / height;

      chunk.markAttributeDirty("a_position");

    }
  }

}
